// assets/sticky-audio.js
console.log('[sticky-audio] loaded');

(function () {
  const qs = (sel, root = document) => root.querySelector(sel);

  function initStickyAudio() {
    const footer = qs('#stickyPlayerFooter');
    const audio = qs('#stickyAudio');
    const titleEl = qs('#playerTrackInfo');
    const playBtn = qs('#stickyPlayPause');
    const playIcon = qs('#stickyPlayIcon');
    const closeBtn = qs('#stickyClose');

    const volSlider = qs('#stickyVolume');
    const muteBtn = qs('#stickyMute');
    const muteIcon = qs('#stickyMuteIcon');

    const waveformWrap = qs('#playerWaveform');
    const productImg = qs('#playerProductImage');
    const productLink = qs('#playerProductLink');
    const priceEl = qs('#playerPrice');


    const atcBtn = qs('#stickyAddToCart');

    if (!footer || !audio || !titleEl || !playBtn) {
      console.warn('[sticky-audio] missing footer/audio elements');
      return;
    }

    // =========================================================
    // VOLUME + MUTE
    // =========================================================
    function setVolFill(v) {
      if (!volSlider) return;
      const pct = Math.round((v || 0) * 100);
      volSlider.style.background =
        `linear-gradient(to right,
          #EAEAEA 0%,
          #EAEAEA ${pct}%,
          rgba(234,234,234,0.2) ${pct}%,
          rgba(234,234,234,0.2) 100%)`;
    }

    function setMuteIcon() {
      if (!muteIcon) return;
      muteIcon.textContent = audio.muted || audio.volume === 0 ? '🔇' : '🔊';
    }

    function applyVolume(v) {
      v = Math.max(0, Math.min(1, Number(v)));
      audio.volume = v;
      if (v > 0) audio.muted = false;
      setVolFill(v);
      setMuteIcon();
    }

    if (volSlider) {
      applyVolume(volSlider.value);
      volSlider.addEventListener('input', (e) => applyVolume(e.target.value));
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', () => {
        audio.muted = !audio.muted;

        // if unmuting while volume is 0, bump to sane value
        if (!audio.muted && audio.volume === 0) {
          audio.volume = 0.9;
          if (volSlider) volSlider.value = String(audio.volume);
          setVolFill(audio.volume);
        }
        setMuteIcon();
      });
    }

    audio.addEventListener('volumechange', () => {
      if (volSlider) volSlider.value = String(audio.volume);
      setVolFill(audio.volume);
      setMuteIcon();
    });

    // =========================================================
    // WAVEFORM (CANVAS)
    // =========================================================
    let waveformData = null;
    let canvas = null;
    let ctx = null;

    const WAVE_SAMPLES = 320;
    const WAVE_PADDING = 10;
    const WAVE_TOPBOTTOM_PADDING = 4;
    const WAVE_GAP = 1.8;
    const BAR_RADIUS = 2;

    const COLOR_UNPLAYED = 'rgba(234,234,234,0.25)';
    const COLOR_PLAYED = '#c084fc';
    const COLOR_PLAYHEAD = '#FF4DDB';

    function ensureCanvas() {
      if (!waveformWrap) return;
      if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.display = 'block';
        waveformWrap.innerHTML = '';
        waveformWrap.appendChild(canvas);
        ctx = canvas.getContext('2d');
      }
      resizeCanvas();
    }

    function resizeCanvas() {
      if (!canvas || !waveformWrap) return;
      const w = waveformWrap.clientWidth;
      const h = waveformWrap.clientHeight;
      if (!w || !h) return;
      const dpr = window.devicePixelRatio || 1;
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function roundRect(ctx, x, y, w, h, r) {
      const rr = Math.min(r, w / 2, h / 2);
      ctx.beginPath();
      ctx.moveTo(x + rr, y);
      ctx.arcTo(x + w, y, x + w, y + h, rr);
      ctx.arcTo(x + w, y + h, x, y + h, rr);
      ctx.arcTo(x, y + h, x, y, rr);
      ctx.arcTo(x, y, x + w, y, rr);
      ctx.closePath();
    }

    function resamplePeaks(data, targetCount) {
      if (!data || data.length === targetCount) return data;
      const out = new Array(targetCount);
      const stride = data.length / targetCount;

      for (let i = 0; i < targetCount; i++) {
        const start = Math.floor(i * stride);
        const end = Math.floor((i + 1) * stride);
        let peak = 0;
        for (let j = start; j < end; j++) peak = Math.max(peak, data[j] || 0);
        out[i] = peak;
      }
      return out;
    }

    function drawWaveform(progress = 0) {
      if (!ctx || !waveformWrap) return;

      const w = waveformWrap.clientWidth;
      const h = waveformWrap.clientHeight;
      if (!w || !h) return;

      ctx.clearRect(0, 0, w, h);

      const iw = Math.max(0, w - WAVE_PADDING * 2);
      const ih = Math.max(0, h - WAVE_TOPBOTTOM_PADDING * 2);
      const ox = WAVE_PADDING;
      const oy = WAVE_TOPBOTTOM_PADDING;
      if (!iw || !ih) return;

      const minBarW = 1;
      const maxBarsThatFit = Math.max(8, Math.floor((iw + WAVE_GAP) / (minBarW + WAVE_GAP)));
      const barCount = Math.min(WAVE_SAMPLES, maxBarsThatFit);

      const base = waveformData || Array.from({ length: WAVE_SAMPLES }, () => 0.35);
      const data = resamplePeaks(base, barCount);

      const n = data.length;
      const clamped = Math.max(0, Math.min(1, progress));
      const playedIndex = Math.floor(clamped * n);

      const barW = (iw - (n - 1) * WAVE_GAP) / n;

      for (let i = 0; i < n; i++) {
        const v = data[i];
        const barH = Math.max(2, v * ih);
        const x = ox + i * (barW + WAVE_GAP);
        const y = oy + (ih - barH) / 2;

        ctx.fillStyle = (i < playedIndex) ? COLOR_PLAYED : COLOR_UNPLAYED;
        roundRect(ctx, x, y, barW, barH, BAR_RADIUS);
        ctx.fill();
      }

      const px = ox + (clamped * iw);
      ctx.fillStyle = COLOR_PLAYHEAD;
      ctx.fillRect(px, oy, 2, ih);
    }

    async function buildWaveformFromUrl(url) {
      if (!url || !waveformWrap) return;

      ensureCanvas();
      drawWaveform(0);

      try {
        const res = await fetch(url, { mode: 'cors', credentials: 'same-origin' });
        const buf = await res.arrayBuffer();

        const AC = window.AudioContext || window.webkitAudioContext;
        const audioCtx = new AC();
        const decoded = await audioCtx.decodeAudioData(buf);

        const channel = decoded.getChannelData(0);
        const blockSize = Math.floor(channel.length / WAVE_SAMPLES);
        const samples = new Array(WAVE_SAMPLES).fill(0);

        for (let i = 0; i < WAVE_SAMPLES; i++) {
          const start = i * blockSize;
          let peak = 0;
          for (let j = 0; j < blockSize; j++) {
            const val = Math.abs(channel[start + j] || 0);
            if (val > peak) peak = val;
          }
          samples[i] = Math.pow(peak, 0.6);
        }

        const max = Math.max(...samples) || 1;
        waveformData = samples.map(v => v / max);

        drawWaveform(audio.duration ? audio.currentTime / audio.duration : 0);
        audioCtx.close?.();
      } catch (err) {
        console.warn('[sticky-audio] waveform failed, using fallback', err);
        waveformData = null;
        drawWaveform(0);
      }
    }

    if (waveformWrap) {
      waveformWrap.addEventListener('click', (e) => {
        if (!audio.duration) return;
        const rect = waveformWrap.getBoundingClientRect();
        const x = e.clientX - rect.left - WAVE_PADDING;
        const iw = rect.width - WAVE_PADDING * 2;
        const pct = Math.max(0, Math.min(1, x / iw));
        audio.currentTime = pct * audio.duration;
      });
    }

    window.addEventListener('resize', () => {
      if (!waveformWrap) return;
      resizeCanvas();
      drawWaveform(audio.duration ? audio.currentTime / audio.duration : 0);
    });

    audio.addEventListener('timeupdate', () => {
      if (!waveformWrap) return;
      const p = audio.duration ? audio.currentTime / audio.duration : 0;
      drawWaveform(p);
    });

    audio.addEventListener('loadedmetadata', () => {
      if (!waveformWrap) return;
      ensureCanvas();
      drawWaveform(0);
    });

    // =========================================================
    // CORE PLAYBACK + CARD STATE
    // =========================================================
    let currentCard = null;

    const showFooter = () => footer.classList.remove('hidden');

    const setPlayState = (isPlaying) => {
      if (playIcon) playIcon.textContent = isPlaying ? '❚❚' : '▶';
    };

    const setCardPlaying = (cardEl, isPlaying) => {
      if (!cardEl) return;
      cardEl.classList.toggle('is-audio-playing', !!isPlaying);
    };

    async function loadAndPlay({ url, title, card }) {
      if (!url) return;

      showFooter();
      titleEl.textContent = title || 'Audio demo';

      try {
  const href  = card?.dataset?.productUrl;
const img   = card?.dataset?.productImage;
const price = card?.dataset?.productPrice;

if (href) {
  if (productLink) productLink.href = href;
  if (titleEl) titleEl.href = href;
}

if (img && productImg) productImg.src = img;
if (priceEl) priceEl.textContent = price || '';

} catch (err) {
  console.warn('[sticky-audio] link/img set failed', err);
}



      if (currentCard && currentCard !== card) setCardPlaying(currentCard, false);
      currentCard = card || currentCard;

      const isSame = audio.dataset.currentUrl === url;
      if (isSame) {
        if (audio.paused) audio.play().catch(() => {});
        else audio.pause();
        return;
      }

      audio.dataset.currentUrl = url;
      audio.src = url;
      audio.currentTime = 0;

      setCardPlaying(currentCard, true);
      buildWaveformFromUrl(url);

      audio.play().catch(() => {
        setPlayState(false);
        setCardPlaying(currentCard, false);
      });
    }

    playBtn.addEventListener('click', () => {
      if (!audio.src) return;
      if (audio.paused) audio.play().catch(() => {});
      else audio.pause();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', () => footer.classList.add('hidden'));
    }

    audio.addEventListener('play', () => {
      setPlayState(true);
      setCardPlaying(currentCard, true);
    });

    audio.addEventListener('pause', () => {
      setPlayState(false);
      setCardPlaying(currentCard, false);
    });

    audio.addEventListener('ended', () => {
      setPlayState(false);
      setCardPlaying(currentCard, false);
    });

    function handleAudioTrigger(e) {
      const trigger = e.target.closest('[data-audio-trigger]');
      if (!trigger) return;

      if (e.pointerType === 'mouse' && e.button !== 0) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      const card = trigger.closest('[data-audio-product-id]');
      if (!card) {
        console.warn('[sticky-audio] trigger clicked but no card found');
        return;
      }

      const url = card.dataset.audioUrl;
      const title = card.dataset.productTitle;
      loadAndPlay({ url, title, card });
      return false;
    }

    document.addEventListener('pointerup', handleAudioTrigger, true);

    // =========================================================
    // ADD TO CART (Dawn 15.2) — updates bubble + drawer reliably
    // =========================================================
async function refreshDawnCartUI() {
  // 1) Always update the bubble by reading cart.js (most reliable)
  const cartRes = await fetch('/cart.js', {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { Accept: 'application/json' }
  });
  const cart = await cartRes.json();

  // Try a few common selectors (Dawn + customized themes)
  const bubbleHost =
    document.querySelector('#cart-icon-bubble') ||
    document.querySelector('a[href*="/cart"].header__icon--cart') ||
    document.querySelector('[data-cart-icon]') ||
    document.querySelector('.header__icon--cart');

  if (bubbleHost) {
    let bubble = bubbleHost.querySelector('.cart-count-bubble');

    if (cart.item_count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubbleHost.appendChild(bubble);
      }

      const visible = cart.item_count < 100 ? String(cart.item_count) : '';
      bubble.innerHTML = `
        <span aria-hidden="true">${visible}</span>
        <span class="visually-hidden">Cart: ${cart.item_count} items</span>
      `;
      bubble.hidden = false;
    } else {
      // cart empty: hide bubble if it exists
      if (bubble) bubble.hidden = true;
    }
  }

  // 2) Optionally refresh the drawer HTML so it matches (without opening it)
  const root = (window.Shopify?.routes?.root) ? window.Shopify.routes.root : '/';
  const sectionsUrl = `${root}?sections=cart-drawer`;

  const secRes = await fetch(sectionsUrl, {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { Accept: 'application/json' }
  });

  if (secRes.ok) {
    const sections = await secRes.json();
    if (sections['cart-drawer']) {
      const existingDrawer = document.querySelector('cart-drawer');
      if (existingDrawer) {
        const tmp = document.createElement('div');
        tmp.innerHTML = sections['cart-drawer'];
        const freshDrawer = tmp.querySelector('cart-drawer');
        if (freshDrawer) existingDrawer.replaceWith(freshDrawer);
      }
    }
  }

  // Let theme scripts react
  document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
}


    async function stickyAddToCart() {
      if (!currentCard) return;

      const variantId = currentCard.dataset.variantId;
      if (!variantId) {
        console.warn('[sticky-audio] missing data-variant-id on card');
        return;
      }

      const originalText = atcBtn?.textContent || 'Add to cart';

      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding…';
      }

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });

        if (!addRes.ok) {
          const errText = await addRes.text();
          throw new Error(`add.js failed: ${addRes.status} ${errText}`);
        }

        await addRes.json();
        await refreshDawnCartUI();

        if (atcBtn) atcBtn.textContent = 'Added';
        setTimeout(() => { if (atcBtn) atcBtn.textContent = originalText; }, 900);
      } catch (err) {
        console.warn('[sticky-audio] ATC error:', err);
        if (atcBtn) atcBtn.textContent = 'Error';
        setTimeout(() => { if (atcBtn) atcBtn.textContent = originalText; }, 1200);
      } finally {
        if (atcBtn) atcBtn.disabled = false;
      }
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', (e) => {
        e.preventDefault();
        stickyAddToCart();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAudio);
  } else {
    initStickyAudio();
  }
})();
